import { component, prop } from '../../../decorators';

import find from 'lodash/find';
import keyBy from 'lodash/keyBy';
import map from 'lodash/map';
import includes from 'lodash/includes';

import FlowHeadersFilter from './flow-headers-filter/flow-headers-filter.vue';

import l10n from '../../../transformers/l10n';

const ITEM_HEIGHT = 33;
const ITEM_MARGING = 1;
const FLOW_PADDING = 2;
const BORDER_WIDTH = 2;
const MIN_COUNT = 1;

const MIN_SCALE = 1;
const MAX_SCALE = 100;
const SCALE_STEP_FOR_BTN = 10;

@component({
   components: { FlowHeadersFilter },
   watch: {
      info: 'refreshHeaders'
   }
})
export default class FlowHeaders {
   @prop({ type: Array, required: true }) info
   @prop({ type: String, required: true }) selected
   @prop({ type: Number, default: 0 }) scrollTop
   @prop({ type: Array, required: true }) appearedTypes
   @prop({ type: Number, required: true }) scale
   @prop({ type: Array, required: true }) types
   @prop({ type: Array, required: true }) expandedTypes

   scaleMin = MIN_SCALE
   scaleMax = MAX_SCALE
   headers = []

   get zoomInTitle() {
      return l10n('flow.zoom-in');
   }

   get zoomOutTitle() {
      return l10n('flow.zoom-out');
   }

   titleForType(type) {
      const tk = this.isExpanded(type) ? 'flow.collapse' : 'flow.expand';
      return l10n(tk);
   }

   isExpanded(type) {
      return includes(this.expandedTypes, type);
   }

   increaseScale() {
      this.changeScale(this.scale + SCALE_STEP_FOR_BTN);
   }

   decreaseScale() {
      this.changeScale(this.scale - SCALE_STEP_FOR_BTN);
   }

   changeScale(scale) {
      scale = Math.min(scale, MAX_SCALE);
      scale = Math.max(scale, MIN_SCALE);
      this.$emit('change-scale', scale);
   }

   calcItemHeight({ type }) {
      const item = find(this.info, { type });
      const lines = item ? item.info.length || MIN_COUNT : MIN_COUNT;
      return lines * ITEM_HEIGHT + FLOW_PADDING + BORDER_WIDTH + ITEM_MARGING;
   }

   refreshHeaders() {
      const cache = keyBy(this.types, 'type');
      this.headers = map(this.info, ({type, hasInfo}) => {
         return {...cache[type], hasInfo};
      });
   }

   toggle(type) {
      this.$emit('toggle', type);
   }

   created() {
      this.refreshHeaders();
   }
}
